import React from 'react';
import { X } from 'lucide-react';
import { NotesFilters, SORT_LABELS } from '../../utils/notesFilterUtils';
import { subjectLabels, universityYearLabels } from '../../utils/noteLabels';

type Props = {
  filters: NotesFilters;
  onRemove: <K extends keyof NotesFilters>(key: K) => void;
  onClearAll: () => void;
};

type Pill = { key: keyof NotesFilters; label: string };

function buildPills(filters: NotesFilters): Pill[] {
  const pills: Pill[] = [];
  if (filters.q) pills.push({ key: 'q', label: `“${filters.q}”` });
  if (filters.subject) pills.push({ key: 'subject', label: subjectLabels[filters.subject] || filters.subject });
  if (filters.university) pills.push({ key: 'university', label: filters.university });
  if (filters.department) pills.push({ key: 'department', label: filters.department });
  if (filters.year) pills.push({ key: 'year', label: universityYearLabels[filters.year] || filters.year });
  if (filters.sort !== 'newest') pills.push({ key: 'sort', label: SORT_LABELS[filters.sort] });
  return pills;
}

const NotesActiveFilters: React.FC<Props> = ({ filters, onRemove, onClearAll }) => {
  const pills = buildPills(filters);
  if (pills.length === 0) return null;

  return (
    <div className="notes-active-filters">
      {pills.map((pill) => (
        <button
          key={pill.key}
          type="button"
          className="notes-active-filters__pill"
          onClick={() => onRemove(pill.key)}
          aria-label={`${pill.label} filtresini kaldır`}
        >
          {pill.label}
          <X size={14} />
        </button>
      ))}
      <button type="button" className="notes-active-filters__clear" onClick={onClearAll}>
        Tümünü temizle
      </button>
    </div>
  );
};

export default NotesActiveFilters;
